cliEntry = require("./cliEntry")
cliEntry.run() if require.main is module
module.exports = cliEntry
